import React from "react"
import BaseLogo from "./icon.svg?react"

export function Logo(props: React.ComponentProps<typeof BaseLogo>) {
	return <BaseLogo width="48" height="48" {...props} />
}

export default Logo
